import React from "react";
import CommonGetInTouchMobile from "./CommonGetInTouchMobile"
import CommonGetInTouchDesktop from "./CommonGetInTouchDesktop"


const CommonGetInTouchBase = ({ profile, isMobile }) => {
  // Hide Get in touch form for zubeen-garg profile
  if (profile?.artist?.slug === 'zubeen-garg') {
    return null;
  }

  return (
    <>
      {isMobile ? (
        <div className="pt-10 max-sm:pt-0 mt-20">
          <CommonGetInTouchMobile profile={profile} />
        </div>
      ) : (
        <div className="pt-10 max-sm:pt-0 px-4 sm:px-6 lg:px-0 w-screen mt-20">
          <CommonGetInTouchMobile profile={profile} />
        </div>
      )}
    </>
  )
}

export default CommonGetInTouchBase
